
import { Vue } from 'vue-class-component';

export default class AppFooter extends Vue {
}
